module.exports = __webpack_public_path__ + "img/25.bbe83ac.png";